<template>
  <div :class="{'nav-open': $sidebar.showSidebar}">
    <notifications transition-name="notification-list" transition-mode="out-in">

    </notifications>
    <router-view name="header"></router-view>
    <transition name="fade"
                mode="out-in">
      <router-view></router-view>
    </transition>
    <router-view name="footer"></router-view>
  </div>
</template>

<script>
  // Loading some plugin css asynchronously
  import 'sweetalert2/dist/sweetalert2.css'
  import 'vue-notifyjs/themes/default.css'
  import { mapGetters } from 'vuex'

  export default {
      name: 'App',
      computed: {
          ...mapGetters('oidcStore', [
              'oidcIsAuthenticated'
          ]),
          hasAccess: function () {
              return this.oidcIsAuthenticated || this.$route.meta.isPublic
          }
      },
      methods: {
          userLoaded: function () {
              console.log('I am listening to the user loaded event in vuex-oidc')
          }
      },
      mounted () {
          window.addEventListener('vuexoidc:userLoaded', this.userLoaded)
      },
      destroyed () {
          window.removeEventListener('vuexoidc:userLoaded', this.userLoaded)
      }
  }
</script>
<style lang="scss">

</style>
